var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_6475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7001 13.645C39.7022 12.9775 37.0785 12.6867 35.1685 13.2022C35.0694 11.3121 34.0847 9.71933 32.2937 8.32487L31.6328 7.88207L31.19 8.54957C30.3243 9.93742 29.9409 11.5764 30.0863 13.2022C30.1723 14.2464 30.5556 15.2443 31.19 16.0836C28.7051 17.5178 26.4184 17.1939 16.2871 17.1939H0.637355C0.591093 19.474 0.961188 23.8556 3.75673 27.4178C4.07395 27.8209 4.411 28.1976 4.77449 28.5611C7.04793 30.828 10.4911 32.4934 15.6328 32.5C23.4775 32.5066 30.1987 28.2836 34.283 18.0795C35.6312 18.0993 39.1801 18.3174 40.9182 14.9734C40.9579 14.9139 41.361 14.0878 41.361 14.0878L40.7001 13.645ZM10.8546 11.5632H6.45313V15.9449H10.8546V11.5632ZM16.5382 11.5632H12.1367V15.9449H16.5382V11.5632ZM22.2218 11.5632H17.8203V15.9449H22.2218V11.5632ZM27.9054 11.5632H23.5039V15.9449H27.9054V11.5632ZM5.17102 11.5632H0.769532V15.9449H5.17102V11.5632ZM10.8546 6.0316H6.45313V10.4133H10.8546V6.0316ZM16.5382 6.0316H12.1367V10.4133H16.5382V6.0316ZM22.2218 6.0316H17.8203V10.4133H22.2218V6.0316ZM22.2218 0.5H17.8203V4.88166H22.2218V0.5Z",
    fill: "#1D63ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_6475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.7237,
    height: 32,
    fill: "white",
    transform: "translate(0.637695 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/Docker.6b96c66ee7ea45edacf86ef2c730964d.svg";
export { ForwardRef as ReactComponent };